import FloatingCompoundTable from "@/components/FloatingCompoundTable.vue";
import { getDescriptionBasedOnKpiKey, getColorsBasedOnRange } from "@/utils/transformers";
import { EVENTS, TREND_DIRECTION_TYPE, KPI_DIRECTION_TYPE, DAYS_INVENTORY_HEATMAP_COLORS, ORGANIC_CVR_HEATMAP_COLORS, BUYBOX_HEATMAP_COLORS, COLORS, ANALYTICS_CSV_PAGE_SIZE, CPC_DECILE_COLORS, CVR_HEATMAP_COLORS, PROFIT_DECILE_COLORS, PROFIT_REVENUE_PERCENTAGE_DECILE_COLORS, FLOATING_COMPOUND_TABLE_STATES, GROUP_BY_TAB_ELEMENTS } from "@/utils/constants";
import { country_code_amz_sp_api_marketplace_ids, amz_sp_api_marketplace_ids_country_domains, country_code_amz_sp_api_marketplace_ids_flipped } from "@/utils/countries";
import { capitalizeWords, formatLink } from "@/utils";
import WrapWithPopover from "@/components/shared/WrapWithPopover.vue";
import PerformanceProductTableGroupBy from "@/components/market_insights/PerformanceProductTableGroupBy.vue";
import { mapState, mapGetters } from "vuex";
import { CATEGORY_FIELD, MARKET_SIZE_FIELD, MARKET_UNITS_SOLD_FIELD, AVERAGE_PRICE_MARKET_FIELD, COMPETITOR_AVERAGE_PRICE_MARKET_FIELD, PRICE_RANGE_FIELD, AVERAGE_PRICE_SELLER_PERFORMANCE_FIELD, SHARE_OF_UNITS_SOLD_FIELD, COMPETITOR_SHARE_OF_UNITS_SOLD_FIELD, MARKET_SHARE_FIELD, COMPETITOR_MARKET_SHARE_FIELD, RANK_FIELD, COMPETITOR_RANK_FIELD, SELLER_FIELD, MARKETPLACE_FIELD, PRODUCT_BRAND_FIELD, RELATIVE_SHARE_VS_LEADER_FIELD, BEST_BRAND_PRODUCT_RANK_FIELD, CATEGORY_REVENUE_SHARE, BRAND_REVENUE_FIELD, BRAND_UNITS_SOLD_FIELD, SELECTOR } from "@/utils/table_fields";
import FlexRow from "@/components/FlexRow.vue";
import { HugValue, DateValue, RateChangeValue, CurrencyValue, NumberValue, BoxedValue, BarWithValue, PercentageValue, DottedValue, OverlapBarValue, EvolutionArrow, SegmentedBar, ImageElement, HashedNumberValue, DottedPositionBar, BarWithDifferenceFromMaxMarked, RangeBar, DotElement, TextValue, ValueElement, MarketplaceValue, ProductValue, BrandParentValue } from "@/components/tableElements";
import WrapWithArrow from "@/components/tableElements/WrapWithArrow.vue";
import PerformanceProductTableTotal from "@/components/market_insights/PerformanceProductTableTotal.vue";
import LiteTableMixin from "@/mixins/LiteTableMixin.vue";
import AppIconGroup from "@/components/AppIconGroup";
import FilterDivider from "@/components/new-filters/FilterDivider.vue";
import DownloadMixin from "@/mixins/DownloadMixin.vue";
import { capitalize } from "vue";
import { processDate } from "@/utils";
import SlotWithEvolutionValue from "@/components/tableElements/SlotWithEvolutionValue.vue";
import EvolutionValue from "@/components/tableElements/EvolutionValue.vue";
import BlockBarWithValue from "@/components/tableElements/BlockBarWithValue.vue";
import BoxAndBarWithValue from "@/components/tableElements/BoxAndBarWithValue.vue";
import BlockStyledBar from "@/components/tableElements/BlockStyledBar.vue";
import WrapWithAlertIcon from "@/components/WrapWithAlertIcon.vue";
import ViewExportDropdown from "@/components/ViewExportDropdown.vue";
import TasksMixin from "@/mixins/TasksMixin.vue";
import { HISTORY_PERIOD_TEXTS } from "../../utils/datepicker";
import AppIcon from "@/components/AppIcon";
import ChevronDownIcon from "@/components/icons/ChevronDownIcon.vue";
import ChevronRightIcon from "@/components/icons/ChevronRightIcon.vue";
export default {
  name: "PerformanceProductTable",
  components: {
    FloatingCompoundTable,
    PerformanceProductTableGroupBy,
    PerformanceProductTableTotal,
    WrapWithPopover,
    HugValue,
    DateValue,
    RateChangeValue,
    CurrencyValue,
    NumberValue,
    BoxedValue,
    BarWithValue,
    PercentageValue,
    DottedValue,
    OverlapBarValue,
    FlexRow,
    SlotWithEvolutionValue,
    EvolutionValue,
    EvolutionArrow,
    SegmentedBar,
    ImageElement,
    HashedNumberValue,
    DottedPositionBar,
    BarWithDifferenceFromMaxMarked,
    RangeBar,
    DotElement,
    TextValue,
    ValueElement,
    MarketplaceValue,
    ProductValue,
    BrandParentValue,
    AppIcon,
    ChevronDownIcon,
    ChevronRightIcon
  },
  emits: ["refresh", "changeDate", "refreshOtherKpis", "restoreEvolutionTable"],
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  mixins: [LiteTableMixin, DownloadMixin, TasksMixin],
  data() {
    return {
      EVENTS,
      TREND_DIRECTION_TYPE,
      KPI_DIRECTION_TYPE,
      DAYS_INVENTORY_HEATMAP_COLORS,
      ORGANIC_CVR_HEATMAP_COLORS,
      BUYBOX_HEATMAP_COLORS,
      COLORS,
      CPC_DECILE_COLORS,
      CVR_HEATMAP_COLORS,
      PROFIT_REVENUE_PERCENTAGE_DECILE_COLORS,
      HISTORY_PERIOD_TEXTS,
      country_code_amz_sp_api_marketplace_ids,
      amz_sp_api_marketplace_ids_country_domains,
      country_code_amz_sp_api_marketplace_ids_flipped,
      evolCategory: {
        prev_period: "_previous_period",
        same_period_ly: "_last_year"
      },
      fieldsSources: {
        default: {
          category: [CATEGORY_FIELD, CATEGORY_REVENUE_SHARE, RANK_FIELD, MARKET_SHARE_FIELD, SHARE_OF_UNITS_SOLD_FIELD, BEST_BRAND_PRODUCT_RANK_FIELD, MARKET_SIZE_FIELD, MARKET_UNITS_SOLD_FIELD, PRICE_RANGE_FIELD, RELATIVE_SHARE_VS_LEADER_FIELD],
          seller: [SELLER_FIELD, RANK_FIELD, MARKET_SHARE_FIELD, SHARE_OF_UNITS_SOLD_FIELD, BEST_BRAND_PRODUCT_RANK_FIELD, MARKET_SIZE_FIELD, MARKET_UNITS_SOLD_FIELD, PRICE_RANGE_FIELD, RELATIVE_SHARE_VS_LEADER_FIELD],
          marketplace: [MARKETPLACE_FIELD, RANK_FIELD, MARKET_SHARE_FIELD, SHARE_OF_UNITS_SOLD_FIELD, BEST_BRAND_PRODUCT_RANK_FIELD, MARKET_SIZE_FIELD, MARKET_UNITS_SOLD_FIELD, PRICE_RANGE_FIELD, RELATIVE_SHARE_VS_LEADER_FIELD],
          competitor: [SELECTOR, COMPETITOR_RANK_FIELD, PRODUCT_BRAND_FIELD, COMPETITOR_MARKET_SHARE_FIELD, BRAND_REVENUE_FIELD, COMPETITOR_SHARE_OF_UNITS_SOLD_FIELD, BRAND_UNITS_SOLD_FIELD, COMPETITOR_AVERAGE_PRICE_MARKET_FIELD]
        }
      },
      CLICK_TO_FILTER_OPTIONS: {
        category: this.categoriesClickToFilter,
        seller: this.sellersClickToFilter,
        marketplace: this.marketplacesClickToFilter
      },
      CLICK_TO_CLEAR_FILTER_OPTIONS: {
        category: this.categoriesClickToClearFilter,
        seller: this.sellersClickToClearFilter,
        marketplace: this.marketplacesClickToClearFilter
      }
    };
  },
  computed: {
    ...mapState({
      groupBy: state => state.market_insights.product_table.group_by_text,
      productTable: state => state.market_insights.product_table,
      currentTabValue: state => state.market_insights.currentTabValue,
      periodCategory: state => state.market_insights.periodCategory,
      currencyConfig: state => state.market_insights.currencyConfig,
      categories_filter: state => state.market_insights.categories_filter,
      sellers_filter: state => state.market_insights.sellers_filter,
      marketplaces_filter: state => state.market_insights.marketplaces_filter,
      competitor_parents: state => state.market_insights.product_table.competitor_parents,
      period: state => state.market_insights.period
    }),
    ...mapGetters(["marketInsightsSingleMarketplace", "getCountryFlag"]),
    filteredItems() {
      const rows = this.productTable[this.currentTabValue].data[this.groupBy]?.items;
      return rows;
    },
    total() {
      return this.productTable[this.currentTabValue].data[this.groupBy]?.total;
    },
    minMax() {
      //console.log('minMax', this.productTable[this.currentTabValue].data[this.groupBy]?.minMax);
      return this.productTable[this.currentTabValue].data[this.groupBy]?.minMax;
    },
    sort() {
      return this.productTable[this.currentTabValue].data[this.groupBy]?.sort;
    },
    maxCharCount() {
      return this.productTable[this.currentTabValue].data[this.groupBy]?.maxCharCount;
    },
    fields() {
      return this.fieldsSources[this.currentTabValue][this.groupBy];
    },
    datePickerDate() {
      return this.productTable[this.currentTabValue].period;
    },
    page: {
      set(val) {
        this.$store.dispatch("marketInsightsSetProductTablePage", val);
        this.$emit("refresh");
      },
      get() {
        return this.$store.getters.marketInsightsGetProductTablePage();
      }
    },
    perPage: {
      set(val) {
        this.$store.dispatch("marketInsightsSetProductTablePerPage", val);
        this.$emit("refresh");
      },
      get() {
        return this.$store.getters.marketInsightsGetProductTablePerPage();
      }
    },
    totalPages: {
      set(val) {
        this.$store.dispatch("marketInsightsSetProductTableTotalPages", val);
      },
      get() {
        return this.$store.getters.marketInsightsGetProductTableTotalPages();
      }
    },
    getTbodyTrClass() {
      if (this.groupBy === "competitor") {
        return item => {
          const parent = this.competitor_parents.get(item?.brand);
          if (parent) {
            const collapsed = parent.collapsed;
            const last_item = item?.is_child_asin && (item.last_child || !parent.view_all && item.index + 1 == 5) ? `last-child` : "";
            const is_child = item?.is_child_asin ? `is-child` : "";
            const brand = item?.brand || "";
            const belongs_to_seller = item.belongs_to_seller;
            const show = collapsed && (item.is_parent || parent.view_all || item.is_child_asin && !parent.view_all && item.index < 5) ? "visible" : "hidden";
            return `item-row ${show} ${belongs_to_seller ? "seller" : ""} ${last_item} ${is_child} ${brand} ${this.handleRowClass(item, this.filteredItems)}`;
          }
          return null;
        };
      }
      return item => this.handleRowClass(item, this.filteredItems);
    },
    getThClass() {
      return field => {
        return [];
      };
    }
  },
  methods: {
    getDescriptionBasedOnKpiKey,
    capitalizeWords,
    formatLink,
    handleDatePickerSubmit(date) {
      this.$emit("changeDate", date);
      this.$emit("restoreEvolutionTable");
      window.$bus.trigger(EVENTS.FLOATING_COMPOUND_TABLE_OPEN_COLLAPSE);
    },
    handleTableState(state) {
      this.$store.dispatch("marketInsightsSetProductTableState", state);
    },
    handleGroupByRefresh() {
      this.$emit("refresh");
    },
    handleClicked() {
      window.$bus.trigger(EVENTS.FLOATING_COMPOUND_TABLE_OPEN_COLLAPSE);
    },
    async categoriesClickToFilter(item) {
      // Set the `category` filter
      this.categories_filter.selectOnly({
        id: item.category_id
      }, "id");
      this.categories_filter.apply();
      this.$emit("refreshOtherKpis");
    },
    async categoriesClickToClearFilter() {
      // Set the `category` filter
      this.categories_filter.clear();
      this.categories_filter.apply();
      await this.$emit("refreshOtherKpis");
    },
    async sellersClickToFilter(item) {
      // Set the `seller` filter
      this.sellers_filter.selectOnly({
        id: item.seller_id
      }, "id");
      this.sellers_filter.apply();
      await window.$bus.trigger(EVENTS.REFRESH_MARKET_INSIGHTS_SELLERS_SUB_FILTERS);
      this.$emit("refreshOtherKpis");
    },
    async sellersClickToClearFilter() {
      // Set the `seller` filter
      this.sellers_filter.clear();
      this.sellers_filter.apply();
      await window.$bus.trigger(EVENTS.REFRESH_MARKET_INSIGHTS_SELLERS_SUB_FILTERS);
      await this.$emit("refreshOtherKpis");
    },
    async marketplacesClickToFilter(item) {
      this.marketplaces_filter.selectOnly({
        marketplace_id: country_code_amz_sp_api_marketplace_ids[item.country_code]
      }, "marketplace_id");

      // Set the current group by to `product`
      this.marketplaces_filter.apply();
      await window.$bus.trigger(EVENTS.REFRESH_MARKET_INSIGHTS_MARKETPLACES_SUB_FILTERS);
      await this.$emit("refreshOtherKpis");
    },
    async marketplacesClickToClearFilter() {
      // Set the `marketplace` filter
      this.marketplaces_filter.clear();
      this.marketplaces_filter.apply();
      await window.$bus.trigger(EVENTS.REFRESH_MARKET_INSIGHTS_MARKETPLACES_SUB_FILTERS);
      await this.$emit("refreshOtherKpis");
    },
    async handleBreakdownReset() {
      const clickToClearFilter = this.CLICK_TO_CLEAR_FILTER_OPTIONS[this.groupBy];
      await clickToClearFilter();
    },
    async handleBreakdownSelect(item) {
      const clickToFilter = this.CLICK_TO_FILTER_OPTIONS[this.groupBy];
      await clickToFilter(item);
    },
    async handleRowClick(item, _, event) {
      //console.log('handleRowClick', event)
      const performanceFloatingCompoundTable = this.$refs.performanceFloatingCompoundTable;
      if (this.groupBy === "competitor") {
        if (!item.is_child_asin) {
          this.$store.dispatch("marketInsightsToggleCompetitorState", item?.brand);
        }
      } else {
        if (performanceFloatingCompoundTable) {
          performanceFloatingCompoundTable.handleNormalize();
        }
        this.handleBreakdownRowClicked(item, this.handleBreakdownReset, this.handleBreakdownSelect, this.filteredItems);
      }
    },
    toggleViewAll(item) {
      this.$store.dispatch("marketInsightsToggleCompetitorViewAllState", item?.brand);
    },
    getImageChannels(list) {
      let result_list = [];
      list.forEach(item => {
        result_list.push({
          redirect_link: `https://${item.amazon_link}`,
          sales_channel: amz_sp_api_marketplace_ids_country_domains[item.marketplace_id],
          flag: this.getCountryFlag(country_code_amz_sp_api_marketplace_ids_flipped[item.marketplace_id])
        });
      });
      return result_list;
    },
    getMarginForItem(item, key) {
      const parent = this.competitor_parents.get(item?.brand);
      let cumulative_margin_percent = parent[`${key}_preceding`];
      if (item.is_child_asin) {
        cumulative_margin_percent += parent[`${key}_children`][item.asin];
      }
      return `${cumulative_margin_percent * 100}%`;
    }
  }
};